<template>
	<div class="om-custom-integrations">
		<div class="content">
			<h2>Don't See Yours?</h2>
			<p>
				You’re not limited to our existing integrations!
				<br>Integrate with any email provider or CRM using Custom HTML, Zapier or Webhooks.
			</p>

			<div class="om-custom-integrations-cards">
				<div v-for="provider in providers" v-bind:key="provider.slug" class="custom-integration-card">
					<div class="custom-integration-card-inner" @click="handleCardAction(provider.slug)">
						<img v-if="image" class="omapi-integration-card__image" :src="image(provider)">
						<div v-if="provider.name" class="omapi-integration-card__name">
							{{ provider.name }}
						</div>
						<div class="omapi-integration-card__cta">
							<span>Connect &rarr;</span>
						</div>
					</div>
				</div>
			</div>
			<div class="om-custom-integrations-learn-more">
				<span>Learn more about using our <core-button
					:href="$urls.docs('how-to-connect-optinmonster-with-any-custom-html-form', 'Integrations')"
					:linkStyle="true"
					:isLink="true"
					target="_blank" rel="noopener"
				>Custom HTML</core-button>, <core-button
					:href="$urls.docs('connect-optinmonster-with-zapier', 'Integrations')"
					:linkStyle="true"
					:isLink="true"
					target="_blank" rel="noopener"
				>Zapier</core-button>, and <core-button
					:href="$urls.docs('how-to-connect-optinmonster-with-a-webhook', 'Integrations')"
					:linkStyle="true"
					:isLink="true"
					target="_blank" rel="noopener"
				>Webhook</core-button> integrations</span>
			</div>
		</div>
	</div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const { mapActions, mapGetters, mapMutations } = createNamespacedHelpers('integrations')

export default {
	computed : {
		...mapGetters([
			'getProvider',
		]),
		providers () {
			return [
				'custom',
				'zapier',
				'webhook',
			].map(slug => this.getProvider(slug))
		},
	},
	methods : {
		...mapActions([
			'connectProvider',
		]),
		...mapMutations([
			'clearFilter',
			'clearSearch',
		]),
		/**
		 * Image
		 *
		 * @since 2.4.0
		 *
		 * @param {Object} provider The provider.
		 *
		 * @returns {Object} The provider image/logo.
		 */
		image (provider) {
			if (provider.logo) {
				return provider.logo
			}

			const images = require.context('../../../assets/images/providers/', false, /\.png$/)
			const image  = provider.slug ? images(`./${provider.slug}.png`) : ''

			return image
		},
		/**
		 * Handle Card Action
		 *
		 * @since 2.4.0
		 *
		 * @param {string} slug The provider slug.
		 *
		 * @returns {void}
		 */
		handleCardAction (slug) {
			if (!this.$store.getters.connected) {
				return this.$modal.show('not-connected')
			}

			this.clearFilter()
			this.clearSearch()
			this.connectProvider(slug)
			this.$modal.hide('custom-integrations')
		},
	},
}
</script>

<style lang="scss">
@import '../../../assets/scss/variables';

.om-custom-integrations {
	.content {
		align-items: center;
		display: flex;
		flex-direction: column;
		padding: 0 90px 40px!important;

		h2 {
			font-weight: $font_bold;
			text-align: center;
			font-size: 24px;
			line-height: 140%;
			margin-top: 10px;
		}

		p {
			font-size: 16px;
			text-align: center;
			padding: 0 35px;
		}

		.om-custom-integrations-cards {
			margin-bottom: 20px;
		}
	}

	&-learn-more {
		a {
			font-size: 14px;
		}
	}
}
.om-custom-integrations-cards {
	display: flex;
	justify-content: space-between;
	width: 100%;

	.custom-integration-card {
		background-color: #fff;
		border: 2px solid #c9d0d6;
		display: flex;
		height: 176px;
		width: 219px;
		border-radius: 3px;

		&:hover {
			box-shadow: $card_box-shadow;
			border-color: $color_blue-primary;
			cursor: pointer;
		}

		.custom-integration-card-inner {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			width: 100%;
		}
	}
}
</style>
